import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ValidationErrors} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {InputWrapperComponent} from '../input-wrapper/input-wrapper.component';
import {MultiSelectChangeEvent, MultiSelectModule} from "primeng/multiselect";

@Component({
  selector: 'app-input-multiselect',
  standalone: true,
  imports: [
    CommonModule,
    InputWrapperComponent,
    FormsModule,
    MultiSelectModule
  ],
  templateUrl: './input-multiselect.component.html',
  styleUrls: ['./input-multiselect.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputMultiselectComponent),
      multi: true
    }
  ]
})
export class InputMultiselectComponent implements ControlValueAccessor {
  @Input() label?: string;
  @Input() label2?: string;
  @Input() labelOnPress?: () => void;
  @Input() valueLabel?: string;
  @Input() required?: boolean;
  @Input() errorMessage?: ValidationErrors | null;
  @Input() touched?: boolean;
  @Input() alt?: boolean;
  @Input() onPress?: () => void;
  @Input() disabled?: boolean;
  @Input() readonly?: boolean;
  @Input() placeholder?: string = '';
  @Input() options: any[] = [];  // Dropdown options
  @Input() optionLabel: string = 'label';  // The label field for options
  @Input() optionValue: string = 'value';  // The value field for options
  @Input() group = false;  // Whether options are grouped
  @Input() maxSelectedLabels = 3;
  @Input() leftIcon?: string;
  @Input() rightIcon?: string;
  @Output() change = new EventEmitter<MultiSelectChangeEvent>();
  @Input() filter?: boolean;

  value: any;

  onChange = (value: MultiSelectChangeEvent) => {
  };

  onTouched = () => {
  };

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  handleSelectChange(event: MultiSelectChangeEvent): void {
    this.onChange(event.value)
    this.onTouched()
    this.change.emit(event)
  }
}
